var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBtn',{staticClass:"modeBtn help",attrs:{"text":"Help","icon":{
        color: 'white',
        height: '15',
        name: 'help',
        width: '15',
    }},nativeOn:{"click":function($event){return _vm.toggleHelp(_vm.force, _vm.editor)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }